export default __webpack_public_path__ + "static/media/einvoice_enter_otp.627da71d.png";